import React, { useCallback, useEffect, useState } from 'react'
import Page, { Container, PageHeader, Row } from '@zera-admin/page'
import Spinner from '@zera-admin/spinner'
import Button from '@zera-admin/button'
import Icon from '@zera-admin/icon'
import MainLayout from 'layouts/main'
import mobileReportService from 'services/http/report/agenda-report'
import { TouristDisturbanceSettingsProps, ReportSetting } from './types'
import { LoadingView } from 'pages/person-report/PersonReport.styled'
import * as Styled from './TouristDisturbanceSettings.styled'
import KeywordEditor from './components/KeywordEditor'

const TouristDisturbanceSettings: React.FunctionComponent<TouristDisturbanceSettingsProps> = ({
  match,
}) => {
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [isSaving, setIsSaving] = useState<boolean>(false)
  const [settings, setSettings] = useState<ReportSetting[]>([])
  const [selectedType, setSelectedType] = useState<'TR' | 'OTH' | null>(null)
  const [showTypeSelector, setShowTypeSelector] = useState<boolean>(true)

  const fetchSettings = useCallback(() => {
    setIsLoading(true)
    mobileReportService
      .TouristDisturbanceSettings()
      .then((res) => {
        setSettings(res.data.data.reportSettings)
        setIsLoading(false)
      })
      .catch((err: Error) => {
        console.log(err)
        setIsLoading(false)
      })
  }, [])

  useEffect(() => {
    fetchSettings()
  }, [fetchSettings])

  const handleTypeSelect = (type: 'TR' | 'OTH') => {
    setSelectedType(type)
    setShowTypeSelector(false)
  }

  const handleSaveSettings = async (updatedSettings: ReportSetting) => {
    setIsSaving(true)
    try {
      await mobileReportService.TouristDisturbanceSettingsUpdate({
        type: updatedSettings.type,
        primaryKeywords: updatedSettings.primaryKeywords,
        secondaryKeywords: updatedSettings.secondaryKeywords,
        tertiaryKeywords: updatedSettings.tertiaryKeywords || [],
      })
      
      // Başarılı kaydetme sonrası ayarları yeniden yükle
      await fetchSettings()
      alert('Ayarlar başarıyla kaydedildi!')
    } catch (error) {
      console.error('Ayarlar kaydedilirken hata oluştu:', error)
      alert('Ayarlar kaydedilirken bir hata oluştu!')
    } finally {
      setIsSaving(false)
    }
  }

  const handleBackToTypeSelector = () => {
    setShowTypeSelector(true)
    setSelectedType(null)
  }

  const selectedSetting = settings.find(setting => setting.type === selectedType)

  if (showTypeSelector) {
    return (
      <MainLayout isLoading={false}>
        <Container width="wide">
          <Page style={{ width: '100%' }}>
            <PageHeader>
              Turist Rahatsızlığı Raporu Ayarları - Tip Seçimi
            </PageHeader>
            <Row xs={{ direction: 'column', align: 'center' }}>
              <div style={{ 
                display: 'flex', 
                flexDirection: 'column', 
                gap: '20px', 
                alignItems: 'center',
                padding: '50px 0'
              }}>
                <h3>Lütfen düzenlemek istediğiniz rapor tipini seçin:</h3>
                <div style={{ display: 'flex', gap: '20px' }}>
                  <Button
                    onClick={() => handleTypeSelect('TR')}
                    style={{ minWidth: '120px' }}
                  >
                    TR Tipi (Türkiye)
                  </Button>
                  <Button
                    onClick={() => handleTypeSelect('OTH')}
                    style={{ minWidth: '120px' }}
                  >
                    OTH Tipi (Yabancı)
                  </Button>
                </div>
              </div>
            </Row>
          </Page>
        </Container>
      </MainLayout>
    )
  }

  return isLoading || isSaving ? (
    <LoadingView>
      <Spinner size="large" />
      <h5>{isSaving ? 'Ayarlar kaydediliyor...' : 'Ayarlar yükleniyor...'}</h5>
    </LoadingView>
  ) : (
    <MainLayout isLoading={isLoading}>
      <Container width="wide">
        <Page style={{ width: '100%' }}>
          <PageHeader
            actions={
              <Button
                style={{ marginLeft: '10px' }}
                onClick={handleBackToTypeSelector}
              >
                Tip Değiştir
              </Button>
            }
          >
            Turist Rahatsızlığı Raporu Ayarları - {selectedType === 'TR' ? 'Türkiye' : 'Yabancı'}
          </PageHeader>
          <Row xs={{ direction: 'column', align: 'center' }}>
            <Styled.SettingsContainer>
              {selectedSetting && (
                <KeywordEditor
                  setting={selectedSetting}
                  onSave={handleSaveSettings}
                  isSaving={isSaving}
                />
              )}
            </Styled.SettingsContainer>
          </Row>
        </Page>
      </Container>
    </MainLayout>
  )
}

export default TouristDisturbanceSettings 